import * as Sentry from '@sentry/react';

export type SentryIdentity = Partial<
  Record<'room_id' | 'main_room_id' | 'session_id' | 'participant_id' | 'support_id', string> & {
    is_breakout: boolean;
  }
>;

// Tags only reach error events; Sentry Logs read scope attributes and ignore tags.
export function setSentryIdentity(identity: SentryIdentity) {
  Sentry.setTags(identity);
  Sentry.setAttributes(identity);
}
